'use strict';

Function.prototype.bind = function(oThis) {
  if (typeof this !== 'function') {
    // closest thing possible to the ECMAScript 5
    // internal IsCallable function
    throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
  }

  var aArgs   = Array.prototype.slice.call(arguments, 1),
      fToBind = this,
      fNOP    = function() {},
      fBound  = function() {
        return fToBind.apply(this instanceof fNOP
               ? this
               : oThis,
               aArgs.concat(Array.prototype.slice.call(arguments)));
      };

  if (this.prototype) {
    // Function.prototype doesn't have a prototype property
    fNOP.prototype = this.prototype;
  }
  fBound.prototype = new fNOP();

  return fBound;
};

require('./client/components/common/student_subnav');
require('./analyticsWatcher/analyticsWatcher');
require('./restrictedFeatures/restrictedFeatures');

export { openVitalSourceEbook } from './version4/wastatic/common/js/vitalsource';
export { analyticsWatcher, getEventQueue, resetEventQueue } from './analyticsWatcher/analyticsWatcher';
export { setUserFeatureSettingAndNavigate } from './restrictedFeatures/restrictedFeatures';
